export enum CatalogProductType {
  AXIOMA_W1 = 'axioma_w1',
  ELECTRICAL_CABINET = 'electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  RUUVI_TAG = 'ruuvi_tag',
  HEATER = 'heater',
  GENERATOR = 'generator',
  AURORA = 'aurora',
  SPINE_MULTI_MEASUREMENT = 'spine_multi_measurement'
}
